import { render } from "./SpineLayout.vue?vue&type=template&id=b5ddcdd4&scoped=true"
import script from "./SpineLayout.vue?vue&type=script&lang=js"
export * from "./SpineLayout.vue?vue&type=script&lang=js"

import "./SpineLayout.vue?vue&type=style&index=0&id=b5ddcdd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ddcdd4"]])

export default __exports__